export const appCalendar = "TleiQe";
export default {appCalendar};